/**
 * The member's reduced-motion setting as it stands, for `canCrossfade` below.
 * Components use `useReducedMotion`, which re-renders on a change.
 *
 * Kept current by a listener rather than asked for each time: `matchMedia(…)
 * .matches` brings style up to date to answer, and asked inside the commit that
 * swaps a pending page for its content it restyled the whole document there —
 * 26ms of that commit at 4x CPU, measured.
 */
let query: MediaQueryList | null = null
let reduced = false

function prefersReducedMotionNow(): boolean {
  if (query === null) {
    query = window.matchMedia('(prefers-reduced-motion: reduce)')
    reduced = query.matches
    query.addEventListener('change', (event) => {
      reduced = event.matches
    })
  }
  return reduced
}

/**
 * Whether a swap here gets a crossfade at all: a card's skeleton leaving over
 * its content (useSkeletonTiming), a pending page's copy over its loaded page
 * (page-frame.ts), a region's old content over its new (refresh.ts). Not
 * without Web Animations (jsdom), where nothing would fade the leaving layer
 * and a test would find it standing, and not under reduced motion, where the
 * swap is a cut and the layer would only linger unseen.
 */
export function canCrossfade(): boolean {
  return typeof document.getAnimations === 'function' && !prefersReducedMotionNow()
}
